import { Directive, OnInit, ElementRef, TemplateRef, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[visibleOwnerIncident]'
})
export class VisibleOwnerIncidentDirective  {
  private currentUser;
  private evaluaciones = [];

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {
  }

  @Input()
  set visibleOwnerIncident(val) {
    this.evaluaciones = val;
    this.updateView();
  }

  private updateView() {
    if (this.checkVisible()) {
        this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private checkVisible() {
    const status = this.evaluaciones[0];
    const perfil = this.evaluaciones[1];

    if (status === 1) {
      if (perfil !== 'owner') {
        return true;
      }
    }
    return false;
  }
}
